import { render, staticRenderFns } from "./providers.vue?vue&type=template&id=63e6724f"
import script from "./providers.vue?vue&type=script&lang=js"
export * from "./providers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports